module.exports = __webpack_public_path__ + "media/theme/step-close-1989cc4d.png";